package com.trevorwiebe.timesheet.admin.customer.data

import com.trevorwiebe.timesheet.admin.customer.domain.CustomerRepository
import com.trevorwiebe.timesheet.core.data.FirestoreListenerRegistry
import com.trevorwiebe.timesheet.core.data.Utils.errorWrapper
import com.trevorwiebe.timesheet.core.domain.CoreRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.core.domain.dto.CustomerDto
import com.trevorwiebe.timesheet.core.domain.dto.toCustomer
import com.trevorwiebe.timesheet.core.domain.dto.toCustomerDto
import com.trevorwiebe.timesheet.core.domain.model.Customer
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class CustomerRepositoryImpl(
    private val firebaseDatabase: Firebase,
    private val coreRepository: CoreRepository
) : CustomerRepository {

    override suspend fun getCustomers(): Flow<TSResult> {
        val orgIdResult = coreRepository.getOrganizationId()
        if (orgIdResult.error != null) return kotlinx.coroutines.flow.flow { emit(orgIdResult) }
        val orgId = orgIdResult.data as String

        val flow = firebaseDatabase.firestore
            .collection("organizations")
            .document(orgId)
            .collection("customers")
            .snapshots
            .map { snapshot ->
                snapshot.documents
                    .map { doc -> doc.data<CustomerDto>().toCustomer(id = doc.id) }
                    .sortedBy { it.contactName.lowercase() }
            }
            .map { TSResult(data = it) }

        return FirestoreListenerRegistry.registerFlow(flow)
    }

    override suspend fun addCustomer(customer: Customer): TSResult {
        return errorWrapper {
            val orgId = coreRepository.getOrganizationId().data as String
            val result = firebaseDatabase.firestore
                .collection("organizations")
                .document(orgId)
                .collection("customers")
                .add(customer.toCustomerDto())
            TSResult(data = result.id)
        }
    }

    override suspend fun updateCustomer(customer: Customer): TSResult {
        return errorWrapper {
            val orgId = coreRepository.getOrganizationId().data as String
            firebaseDatabase.firestore
                .collection("organizations")
                .document(orgId)
                .collection("customers")
                .document(customer.id)
                .set(customer.toCustomerDto(), merge = true)
            TSResult(data = "Customer updated successfully")
        }
    }
}
